module.exports = __webpack_public_path__ + "static/img/Cardfooter06.7b0af8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cardfooter06.png
// module id = ZheE
// module chunks = 1